/* global $ mymuesli */

(function () {

    // Predefine to preload interface
    App.Interface.Colors;

    const FlavourFlowerEntity = mymuesli.entities.FlavourFlower;

    /**
     * Order of the leaf paths by intensity. The order determines the z-index and so the click-ability.
     *
     * @type {number[]}
     * @private
     */
    const _intensities = [3, 2, 1, 0];

    /**
     * SVG paths for all leafs.
     *
     * @type {{sweet: string[], creamy: string[], crunchy: string[], savoury: string[], sour: string[]}}
     * @private
     */
    const _paths = {
        'sweet': [
            '',
            'M453.1,444.6L453.1,444.6l46.9,61.1l46.9-61.1h0c6.9-9.1,11.1-20.3,11.1-32.4c0-30.4-25.9-55.1-57.9-55.1c-32,0-57.9,24.7-57.9,55.1C442.1,424.3,446.2,435.5,453.1,444.6',
            'M402.8,377.5L402.8,377.5l97.7,127.4l97.7-127.4h-0.1c14.5-18.9,23.1-42.3,23.1-67.5 c0-63.4-54.1-114.8-120.7-114.8c-66.7,0-120.7,51.4-120.7,114.8C379.8,335.3,388.3,358.6,402.8,377.5',
            'M352,312.5L352,312.5l148,193l148-193H648c22-28.7,34.9-64,34.9-102.2c0-96.1-81.9-174-182.9-174s-182.9,77.9-182.9,174C317.1,248.5,330.1,283.8,352,312.5'
        ],
        'creamy': [
            '',
            'M400.5,542.9L400.5,542.9l79-24.3L430.6,455v0c-7.3-9.4-17.6-16.9-30.3-20.8c-31.8-9.8-66,6.6-76.2,36.6c-10.3,30,7.2,62.3,39,72.1C375.7,546.7,388.7,546.5,400.5,542.9',
            'M322.3,568.5L322.3,568.5l158.8-48.8l-98.1-127.9v0c-14.6-19-35.5-34-60.9-41.8c-64-19.7-132.6,13.2-153.3,73.6c-20.7,60.3,14.4,125.2,78.4,144.9C272.5,576.2,298.7,575.7,322.3,568.5',
            'M240.6,592.8L240.6,592.8l239.5-73.6l-148-193l0,0.1c-22-28.6-53.5-51.2-91.9-63c-96.5-29.7-200,20-231.2,111c-31.2,91,21.7,188.8,118.2,218.5C165.5,604.5,205,603.7,240.6,592.8'
        ],
        'crunchy': [
            '',
            'M487.7,622L487.7,622l0-80.7l-81.1,24.9l0,0c-12,3.7-23,10.9-31,21.4c-20.2,26.3-14.1,63.1,13.5,82.1c27.7,19,66.4,13.1,86.6-13.2C483.8,646.1,487.7,634,487.7,622',
            'M487.7,698L487.7,698l0-156.7l-157.4,48.4l0,0c-23.4,7.2-44.7,21.2-60.2,41.5c-39.2,51.1-27.4,122.4,26.3,159.3c53.7,36.9,129,25.5,168.2-25.6C480.1,744.8,487.6,721.3,487.7,698',
            'M487.7,779.8L487.7,779.8l0.1-238.5L248.2,615l0.1,0c-35.6,11-68,32.3-91.7,63.2c-59.6,77.7-41.7,186.3,40,242.6c81.7,56.2,196.3,38.8,256-38.9C476.2,851,487.6,815.2,487.7,779.8'
        ],
        'savoury': [
            '',
            'M591.4,565.6L591.4,565.6l-78.9-24.3V620l0,0c0,11.7,3.8,23.5,11.6,33.7c19.7,25.6,57.4,31.4,84.4,12.8c26.9-18.5,32.8-54.3,13.2-80C613.8,576.3,603.1,569.3,591.4,565.6',
            'M671,589.4L671,589.4l-158.8-48.9v158.1l0,0c0,23.5,7.6,47.2,23.3,67.7c39.5,51.5,115.5,63.1,169.7,25.8c54.2-37.3,66.1-109.3,26.5-160.8C716.1,610.8,694.6,596.7,671,589.4',
            'M751.9,615.1L751.9,615.1l-239.6-73.8V780l0.1,0c0.1,35.5,11.5,71.3,35.2,102.2c59.7,77.8,174.4,95.2,256.1,39c81.8-56.3,99.7-164.9,40-242.7C820,647.5,787.5,626.1,751.9,615.1'
        ],
        'sour': [
            '',
            'M568.9,456.3L568.9,456.3l-48.7,63.4l78.7,24.2v0c11.7,3.6,24.7,3.9,37.3,0c31.7-9.8,49.1-41.9,38.9-71.8c-10.3-29.9-44.3-46.2-76-36.5C586.4,439.4,576.1,446.9,568.9,456.3',
            'M615.8,392.9L615.8,392.9l-97,126.3l156.9,48.3v0c23.3,7.1,49.2,7.7,74.3-0.1c63.2-19.5,97.9-83.5,77.4-143.1c-20.4-59.6-88.3-92.1-151.4-72.7C650.9,359.4,630.3,374.2,615.8,392.9',
            'M667.9,326.3L667.9,326.3L519.9,519.2l239.5,73.7l0-0.1c35.6,10.9,75.1,11.7,113.4-0.1C969.3,563,1022.3,465.2,991,374.2c-31.2-91-134.7-140.7-231.2-111C721.4,275.1,690,297.7,667.9,326.3'
        ]
    };

    const CURSOR = 'pointer';

    /**
     * A view for flowers.
     */
    class FlavourFlower extends mymuesli.interface.components.AbstractSVGComponent {

        /**
         * Initializes the flower.
         *
         * @param $element The base entity.
         */
        constructor ($element) {
            super($element);
            this._paper.setViewBox(-10, -10, 1020, 1020);
            this._leafs = {};
            this._drawLeafs();
            this._flavourFlowerProfile = new FlavourFlowerEntity($element.data('content'));
            this._flavourFlowerProfile.registerObserver(this);
            this.update();
        }

        /**
         * Draws all leaf paths.
         *
         * @private
         */
        _drawLeafs () {
            const self = this;
            $.each(FlavourFlowerEntity.PROPERTIES, function (_, type) {
                self._leafs[type] = [];
                $.each(_intensities, function (__, intensity) {
                    self._drawLeaf(type, intensity);
                });
            });
        }

        /**
         * Draw the path of a single leaf.
         *
         * @param type The leaf.
         * @param intensity The current leaf intensity.
         * @private
         */
        _drawLeaf (type, intensity) {
            this._leafs[type][intensity] = this._paper.path(_paths[type][intensity]).attr({
                class: type,
                cursor: CURSOR,
                stroke: 'none',
                'stroke-width': intensity === 3 ? '10' : '0',
                'fill-opacity': 0
            });
        }

        /**
         * Update the intensity and coloring of a single leaf.
         *
         * @param type The leaf.
         * @param intensity The current leaf intensity.
         * @private
         */
        _updateLeaf (type, intensity) {
            const leaf = this._leafs[type][intensity];
            const currentIntensity = this._flavourFlowerProfile[type];
            const colors = App.Interface.Colors;
            const color = (intensity <= currentIntensity) ? colors.flavour[type.toUpperCase()] : colors.flavourPastel[type.toUpperCase()];
            if (intensity === 3) {
                leaf.attr({fill: color, stroke: colors.flavour[type.toUpperCase()]});
            } else {
                leaf.attr({fill: color});
            }
            leaf.animate({'fill-opacity': 1}, App.Setting('FX_DURATION_SHORT'), 'ease-in');
        }

        /**
         * Update the leaf intensities.
         */
        update () {
            const self = this;
            $.each(FlavourFlowerEntity.PROPERTIES, function (_, type) {
                $.each(_intensities, function (__, intensity) {
                    self._updateLeaf(type, intensity);
                });
            });
        }

        /**
         * The related model to the view.
         *
         * @returns {*}
         */
        getModel () {
            return this._flavourFlowerProfile;
        }

        /**
         * Calls the generic parser.
         */
        static parse () {
            mymuesli.interface.components.AbstractComponent._parse('.js-flavour-flower', FlavourFlower);
        }

    }

    /* Expose the class and install the components parser. */
    mymuesli.interface.components.FlavourFlower = FlavourFlower;
    App.load(FlavourFlower.parse);

}) ();
